import HexController from 'controllers/hex_controller';

export default class extends HexController {
  static values = {
    acceptedTerms: Boolean,
    acceptTermsUrl: String
  }

  connect() {
    window.sembiAIShowDesignGuidanceAlertDialog = this.showDesignGuidanceAlertModal.bind(this);
    window.sembiAIAcceptTermsAndConditions = this.acceptAITermsAndConditions.bind(this);
  }

  acceptAITermsAndConditions() {
    fetch(this.acceptTermsUrlValue).then(response => {
      if (response.ok) {
        Modalbox.hide();
        this.acceptedTermsValue = true;
        response.json().then(data => {
          document.dispatchEvent(new CustomEvent('design-guidance-changed', { detail: { canShow: data.can_show } }));
          if (!data.can_show) {
            window.sembiAIShowDesignGuidanceAlertDialog();
          }
        });
      } else {
        alert(this.t('Something went wrong while accepting the AI terms and conditions. Please try again.'));
      }
    });
  }


  showTermsAndConditionsDialog() {
    const footer = `<button class='btn btn-link' onclick="Modalbox.hide();">Decline</button>` +
                   `<button class='btn btn-primary' onclick="window.sembiAIAcceptTermsAndConditions();">Accept & Conditnue</button>`;
    const options = {
      title: 'AI Terms and Condition ',
      width: 500,
      center: true,
      transitions: false,
      disableTitle: false,
      tabbed: false,
      defaultFooter: true,
      footer: footer
    };
    const body = `
<div class='ai-terms-and-conditions-body'><label><strong>By using the AI-powered features of this service, you agree to the following terms and conditions:</strong></label>
  <label>Welcome to our AI Generator! By accepting these terms, you agree to use the AI features in accordance with the guidelines outlined below. These terms are designed to ensure a secure, efficient, and ethical use of AI within your instance.</label>
  <label><strong>Key Terms:</strong></label>
  <ul>
    <li>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</li>
    <li>Integer congue lectus vel sem varius elementum.</li>
    <li>Donec et elit id sem dictum vehicula.</li>
    <li>Donec rutrum quam imperdiet justo sollicitudin, non pulvinar ante efficitur.</li>
    <li>Cras at massa tempus, vestibulum lacus non, porta augue.</li>
    <li>Nam eu nulla a lorem congue molestie.</li>
    <li>Nunc ullamcorper arcu eget massa bibendum aliquet.</li>
    <li>Nulla dictum massa vel erat condimentum, ac iaculis nibh pretium.</li>
    <li>Praesent quis metus ullamcorper, malesuada nisi a, dapibus ipsum.</li>
    <li>Aenean eu elit vitae arcu sagittis maximus.</li>
    <li>Proin nec ligula vitae lorem condimentum iaculis et nec magna.</li>
    <li>Nullam finibus nunc ac magna finibus, vel pretium nulla consectetur.</li>
    <li>Cras vel ligula ut nisi imperdiet auctor sit amet at est.</li>
  </ul>
</div>`;

    Modalbox.show(body, options, footer);
  }

  showDesignGuidanceAlertModal(event) {
    if (event) {
      event.preventDefault();
    }
    if (!this.acceptedTermsValue) {
      this.showTermsAndConditionsDialog();
      return;
    }
    const footer = `<button class='btn btn-link' onclick="Modalbox.hide();">Cancel</button>` +
                   `<button class='btn btn-primary' onclick="window.sembiAIOpenDesignGuidanceModal()">Yes, provide guidance</button>`;
    const options = {
      title: 'Design Guidance Needed',
      width: 500,
      center: true,
      transitions: false,
      disableTitle: false,
      tabbed: false,
      defaultFooter: true,
      footer: footer
    };
    const body = '<span>For effective AI test design assistance, please provide:</span><ol><li>A specific testing goal</li><li>Documentation about the system being tested</li></ol>' //$()

    Modalbox.show(body, options, footer);
  }
}
